export const ContextMixin = {
	data() {
		return {
			isMobile: false
		};
	},
	mounted() {
		// Usiamo 1024px come soglia "operativa" per una dashboard medica densa
		this.mediaQueryList = window.matchMedia('(max-width: 1024px)');

		// Check iniziale
		this.isMobile = this.mediaQueryList.matches;

		// Supporto cross-browser (Safari vecchio vs Chrome nuovo)
		if (this.mediaQueryList.addEventListener) {
			this.mediaQueryList.addEventListener('change', this.onDeviceChange);
		} else {
			// Fallback per browser datati
			this.mediaQueryList.addListener(this.onDeviceChange);
		}
	},
	beforeDestroy() {
		if (this.mediaQueryList) {
			if (this.mediaQueryList.removeEventListener) {
				this.mediaQueryList.removeEventListener('change', this.onDeviceChange);
			} else {
				this.mediaQueryList.removeListener(this.onDeviceChange);
			}
		}
	},
	methods: {
		onDeviceChange(e) {
			console.log("Cambio dispositivo rilevato. Is mobile/tablet:", e.matches);
			this.isMobile = e.matches;
		}
	}
};